import { render, staticRenderFns } from "./nineToken.vue?vue&type=template&id=212ca796&scoped=true"
import script from "./nineToken.vue?vue&type=script&lang=js"
export * from "./nineToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ca796",
  null
  
)

export default component.exports